var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付ける教場を選択してください","resourceType":"school","fields":_vm.fields,"items":_vm.school.schools,"totalItems":_vm.totalSchools,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }